export const links = [
  {
    id: 1,
    text: 'Strona Główna',
    url: '/',
  },
  {
    id: 2,
    text: 'Cennik',
    url: '/cennik',
  },
  {
    id: 3,
    text: 'Kontakt',
    url: '/kontakt',
  },
  {
    id: 4,
    text: 'Nagrania',
    url: '/nagrania',
  },
  {
    id: 5,
    text: 'Blog',
    url: '/blog',
  },
];

export const faq = [
  {
    id: 1,
    title: 'Dla kogo są zajęcia?',
    answers: [
      'Uczę osoby na różnych poziomach zaawansowania i w każdym wieku.',
      'Jeżeli dopiero zaczynasz pomogę Ci w nauce pierwszych utworów, wyrobieniu dobrych nawyków i oswojeniu się z instrumentem. Mogęrównież doradzić Ci w kwestii wyboru gitary.',
      'Jeżeli grasz już jakiś czas pomogę Ci rozwinąć Twoje umiejętnościoraz osiągnąć indywidualne muzyczne cele.',
    ],
  },
  {
    id: 2,
    title: 'Czego się ze mną nauczysz?',
    answers: [
      'Jak dobrze grać Twoje ulubione utwory.',
      'Akordów.',
      'Rytmiki.',
      'Technik gry kostką i palcami (fingerstyle).',
      'Gry solowej oraz improwizacji.',
      'Komponowania i aranżacji własnych utworów.',
      'Dla chętnych teoria muzyki.',
    ],
  },
  {
    id: 3,
    title: 'Gdzie odbywają się zajęcia?',
    answers: [
      'U mnie w przystosowanym pomieszczeniu.',
      ' Online przez Skype, Zoom, Teams lub inne komunikatory (po swojej stronie zapewniam dobrą kamerę i mikrofony).',
      'U Ciebie.',
    ],
  },
];
